export default __webpack_public_path__ + "static/media/01_DAIF_Data_03_03.632ed96a.mp4";